<template>

<app-view-list-field align="center" :demoted-icon="field.type" :is-sticky="isSticky" :is-demoted="isDemoted" :field="field" :filter="filter">

	<div class="worth-primary" v-html="formatcurrency(value)" v-if="value"></div>

</app-view-list-field>

</template>

<script>

export default {

	props: ['field', 'filter', 'item', 'isSticky', 'isDemoted'],

    computed: {

		value: function() {

			return (this.item.game.version) ? this.item.game.version.worth.value || this.item.game.worth.value : this.item.game.worth.value

		}

    }

}

</script>

<style scoped>

.worth-primary >>> span.currency {
	font-size: 11px;
	color: #666;
}

</style>